import React, { useState, useEffect } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { CallBackProps } from "react-joyride";

import PageTitle from "../../components/page-title";
import Topbar from "../../components/topbar";
import NavTabs from "../../components/navtabs";
import GuidedTour from "../../components/guided-tour";

import Profile from "./profile";
import Subscription from "./subscription";
import AITraining from "./ai-training";

import { useGuidedTour } from "../../hooks/useGuidedTour";

import { tourGuideCheck } from "../../utils/functions";

const SettingsPage = () => {
  const history = useHistory();
  const routeMatch = useRouteMatch();
  const { pathname } = history.location;
  const [activeTab, setActiveTab] = useState("");

  const { runTour, setRunTour, tourStepIndex, setTourStepIndex } =
    useGuidedTour();

  useEffect(() => {
    const segments = pathname.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 2];
    setActiveTab(lastSegment);
  }, []);

  useEffect(() => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);

    console.log("history_state:", history.location.state);

    const tab = params.get("tab");
    if (tab) setActiveTab(tab);

    tourGuideCheck("settingsTourCompleted", setRunTour);
  }, []);

  const switchTab = (id: string) => {
    setActiveTab(id);
  };

  const settingsTourCallBack = (data: CallBackProps) => {
    const { action, index, status, type } = data;
    console.log(action, index, status, type);

    if (type === "step:after" && action === "prev") {
      setTourStepIndex(index - 1);
    }

    if (type === "step:after" && action === "next") {
      // If the upcoming step is index 3, check if the target component's conditions are met.
      if (index + 1 === 2 && activeTab === "profile") {
        setActiveTab("ai-training");
      }

      setTourStepIndex(index + 1);
    }
    if (status === "finished" || status === "skipped") {
      setTourStepIndex(0);
      setRunTour(false);
      localStorage.setItem("settingsTourCompleted", "true");
    }
  };

  let navigations = [
    {
      label: "Store Profile",
      id: "profile",
      content: <Profile />,
    },
    {
      label: "AI Training Data",
      id: "ai-training",
      content: <AITraining />,
    },
    // {
    //   label: "Billing",
    //   id: "billing",
    //   content: <AITraining />,
    // },
    // {
    //   label: "Advance Settings",
    //   id: "advance-setting",
    //   content: <AITraining />,
    // },
    {
      label: "",
      id: "subscription",
      content: <Subscription />,
    },
  ];

  const settingsDashboardTourSteps = [
    {
      target: "#Store-Profile",
      content: "This tab contains all your store details.",
      disableBeacon: true,
    },
    {
      target: "#profile",
      content: "Here, you can view or edit your store details.",
      disableBeacon: true,
    },
    {
      target: "#AI-Training-Data",
      content:
        "Here you can view and edit your onboarding data to train me on your brand.",
      disableBeacon: true,
    },
    {
      target: "#ai-training",
      content:
        "Use this sub-tab to provide your brand details. The more you provide, the better my recommendations will be.",
      disableBeacon: true,
    },
  ];

  return (
    <React.Fragment>
      <GuidedTour
        steps={settingsDashboardTourSteps}
        runTour={runTour}
        setRunTour={setRunTour}
        tourStepIndex={tourStepIndex}
        setTourStepIndex={setTourStepIndex}
        tourCallBack={settingsTourCallBack}
      />
      <PageTitle title="Settings" />
      <Topbar title="Settings" onSearch={() => {}} hideLayoutStyle />

      <div className="page_container settings_page_container">
        <NavTabs
          activeTab={activeTab}
          toggleTab={(id: string) => switchTab(id)}
          navItems={navigations}
          tabPanes={navigations}
          routeMatch={routeMatch}
        />
      </div>
    </React.Fragment>
  );
};

export default SettingsPage;
